import React from "react";
import { Sun, Moon } from "lucide-react";
import { useCustomTheme } from "../../context/ThemeContext";
import { cn } from "../../lib/cn";

/** Light/dark switch wired to the global ThemeContext. */
export function ThemeToggle({ className, size = 18 }) {
  const { mode, toggleTheme } = useCustomTheme();
  const isDark = mode === "dark";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
      className={cn(
        "inline-flex h-8 w-8 items-center justify-center rounded-md text-text ring-1 ring-inset ring-line/20 transition-colors duration-150 ease-smooth hover:text-ink hover:ring-line/40",
        className
      )}
    >
      {isDark ? <Sun size={size} /> : <Moon size={size} />}
    </button>
  );
}

export default ThemeToggle;
